import { render, staticRenderFns } from "./nav-sidebar.vue?vue&type=template&id=49bd2f10&scoped=true&"
import script from "./nav-sidebar.vue?vue&type=script&lang=js&"
export * from "./nav-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./nav-sidebar.vue?vue&type=style&index=0&id=49bd2f10&lang=scss&scoped=true&"
import style1 from "./nav-sidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd2f10",
  null
  
)

component.options.__file = "nav-sidebar.vue"
export default component.exports